<ng-container [formGroup]="formGroup">
  <mat-form-field class="settings-form__email-input">
    <mat-label>{{ "NOTIFICATION_SERVICE.EDIT.EMAIL_ADDRESS" | translate }}</mat-label>
    <input matInput formControlName="email" />
    <mat-icon matSuffix fontIcon="ec_edit"></mat-icon>
  </mat-form-field>
  <mat-divider big></mat-divider>
  <div class="settings-form__email-checkboxes">
    <div class="settings-form__checkbox-wrapper">
      <mat-checkbox formControlName="energyDataDocuments" [disableRipple]="true" [(indeterminate)]="indeterminate.energyDataDocuments">
        {{ "NOTIFICATION_SERVICE.EDIT.ENERGY_DATA.DOCUMENTS_HEADER" | translate }}
      </mat-checkbox>
      <app-badge [badge]="badges.energyDataDocuments" [tooltipLabel]="badges.energyDataDocuments.key"></app-badge>
    </div>

    <div class="settings-form__sub-checkboxes">
        <mat-checkbox formControlName="energyMonitorDocuments" [disableRipple]="true">
            {{ "NOTIFICATION_SERVICE.EDIT.ENERGY_DATA.ENERGY_MONITOR" | translate }}
        </mat-checkbox>
        <mat-checkbox formControlName="kwpDocuments" [disableRipple]="true">
            {{ "NOTIFICATION_SERVICE.EDIT.ENERGY_DATA.HEAT_PLANNING" | translate }}
        </mat-checkbox>
        <mat-checkbox formControlName="networkPlanningDocuments" [disableRipple]="true">
            {{ "NOTIFICATION_SERVICE.EDIT.ENERGY_DATA.GRID_PLANS" | translate }}
        </mat-checkbox>
        <mat-checkbox formControlName="energyUsageDocuments" [disableRipple]="true">
            {{ "NOTIFICATION_SERVICE.EDIT.ENERGY_DATA.ENERGY_CONSUMPTION" | translate }}
        </mat-checkbox>
    </div>

    <div class="settings-form__checkbox-wrapper">
      <mat-checkbox
        [disableRipple]="true"
        formControlName="energyMonitorNewData"
        [(indeterminate)]="indeterminate.energyMonitorNewData"
      >
        {{ "NOTIFICATION_SERVICE.EDIT.ENERGY_DATA.DATA_HEADER" | translate }}
      </mat-checkbox>
      <app-badge [badge]="badges.energyMonitorNewData" [tooltipLabel]="badges.energyMonitorNewData.key"></app-badge>
    </div>
  </div>
</ng-container>
